import { useCallback, useContext } from 'react';
import { TranslationContext } from './TranslationContext';

export const useTranslation = () => {
  const translations = useContext(TranslationContext);

  return useCallback(
    (key) => {
      return (Object.keys(translations).length && translations[key])
        ? translations[key]
        : key
    },
    [translations]
  );
};
